var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.524536,
    y: 0.594482,
    width: 35.5245,
    height: 35.5245,
    rx: 8.88112,
    fill: "#662AB2",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8857 15.7664H19.0267",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.846 21.687H15.3262",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1765 21.687H20.1368",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6875 17.8609V21.3985C25.6875 23.9962 25.0289 24.6475 22.4015 24.6475H14.1717C11.5444 24.6475 10.8857 23.9962 10.8857 21.3985V15.3149C10.8857 12.7172 11.5444 12.0659 14.1717 12.0659H19.2339",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.987 11.8811H24.3035C24.8142 11.8811 25.2286 12.3474 25.2286 12.8062C25.2286 13.3169 24.8142 13.7313 24.3035 13.7313H21.987V11.8811Z",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.987 13.7312H24.6291C25.2138 13.7312 25.6875 14.1457 25.6875 14.6563C25.6875 15.167 25.2138 15.5814 24.6291 15.5814H21.987V13.7312Z",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2896 15.5813V16.5064",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2896 10.9558V11.8809",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8678 11.8811H21.2469",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8678 15.5813H21.2469",
    stroke: "#662AB2",
    strokeWidth: 1.33217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.18c950f0258270815b43202591506aba.svg";
export { ForwardRef as ReactComponent };